export default class AwardGenerator {
  constructor(config) {
    this.$container = config.$container;
    this.pdfUrl = undefined;
    this.exportId = config.exportId;
    this.exportListId = config.exportListId;
  }

  init() {
    this._initListeners();
    return this;
  }

  _initListeners() {
    this.$container.hide();
    this.pollEndpoint();
  }

  pollEndpoint() {
    if (this.pdfUrl) {
      if (this.$container.is(":visible")) return;

      $('#loading-message').hide();
      this.$container.show();
      $('#template-link').attr('href', this.pdfUrl);

      return;
    }

    $.get(`/awards/${this.exportListId}/waiting.json?export_id=${this.exportId}`, (data) => {
      this.pdfUrl = data.url;
      setTimeout(this.pollEndpoint.bind(this), 2500);
    });
  }
}
